import { React, useEffect, useState, useRef } from 'react';
import Img1 from "../assets/images/icons/nav_salesforce.png";
import { motion, AnimatePresence } from "framer-motion";

const LoadingBox = () => {

    const blackBox = {
        initial: {
          height: "100%",
          bottom: 0,
        },
        animate: {
          height: 0,
          transition: {
            when: "afterChildren",
            duration: 2.5,
            ease: [0.87, 0, 0.13, 1],
          },
        },
      };
      const textContainer = {
        initial: {
          opacity: 1,
        },
        animate: {
          opacity: 0,
          transition: {
            duration: 0.25,
            when: "afterChildren",
          },
        },
      };
      const text = {
        initial: {
          y: 40,
        },
        animate: {
          y: 80,
          transition: {
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
          },
        },
      };

    return (
        <div className='loading-div'>
            <AnimatePresence exitBeforeEnter>
              <motion.div
              key="animation"
                     initial={{ opacity: 0 }}
                     animate={{ opacity: 1, delay:2 }}
                     exit={{ opacity: 0 }}
              >
<motion.div
  className="position-absolute z-50 flex items-center justify-center w-100 bg-redbox"
  initial="initial"
  animate="animate"
  variants={blackBox}

//   onAnimationStart={() => document.body.classList.add("overflow-hidden")}
//   onAnimationComplete={() =>
//     document.body.classList.remove("overflow-hidden")
//   }
>


</motion.div>
</motion.div>
</AnimatePresence>
        </div>
    )
}

export default LoadingBox;